import { Footer } from "../../ui/footer/Footer";
import { Header } from "../../ui/header/Header";
import TwoSidesBox from "../../ui/two-sides-box/TwoSidesBox";
import Content from "./Content";
import DatosInteligentes from "./DatosInteligentes";
import BiSteps from "./BiSteps";
import Otros from "./Otros";
import { useNavigateAndScroll } from "../../../hooks/useNavigateAndScroll";
import WhatsappLink from "../../../utils/WhatsappLink";
import { FaArrowRight } from "react-icons/fa";

const BusinessIntelligence = () => {
  const navigateAndScroll = useNavigateAndScroll();

  const baseUrl = `${process.env.PUBLIC_URL}/assets/imagenes/inteligencia-negocios`;

  const side1 = {
    title: "¡Envianos un mensaje!",
    subtitle:
      "Solicite una demo de BI totalmente gratis, con solo enviar un mensaje.",
    imageURL: baseUrl + "/mail.png",
    button: {
      text: "Solicitar demo",
      onChange: () => navigateAndScroll("/demo", "form"),
      className: "boton-azul-light",
    },
  };

  // const side2 = {
  //   title: "Historias de éxito reales",
  //   subtitle:
  //     "Descubre como nuestros clientes revolucionaron la toma de decisiones con el uso de tableros claves y personalizados.",
  //   imageURL: baseUrl + "/star.png",
  //   // button: {
  //   //   text: "Explora nuestros casos de éxito",
  //   //   onChange: () => navigate("/success-stories"),
  //   //   className: "boton-azul-light",
  //   // },
  // };

  const side2 = {
    title: "Recibir asesoramiento",
    subtitle:
      "Descubrí cómo la inteligencia de negocios puede ayudarte a transformar tu empresa desde adentro.",
    imageURL: `${process.env.PUBLIC_URL}/assets/imagenes/about/productos.png`,
    button: {
      text: "Explorar productos",
      onChange: () => navigateAndScroll("/business-intelligence", "top"),
      className: "boton-azul-light",
      payload: (
        <WhatsappLink>
          <button className="boton-generico boton-azul-light">
            <p>Más info</p>
            <FaArrowRight />
          </button>
        </WhatsappLink>
      ),
    },
    // button: {
    //   text: "Solicitar demo",
    //   onChange: () => navigateAndScroll("/demo", "form"),
    //   className: "boton-azul-light",
    // },
  };

  return (
    <div className="home-wrapper">
      <Header />
      <Content />
      <DatosInteligentes />

      <BiSteps />

      <Otros />

      <div className="footer-background">
        <img
          src={`${process.env.PUBLIC_URL}/assets/imagenes/home/fondo_puntitos.png`}
          className="background-dots"
          alt="background"
        />

        <TwoSidesBox side1={side1} side2={side2} />
        <Footer />
      </div>
    </div>
  );
};

export default BusinessIntelligence;
